import { lazy } from 'react'

export const WrappedBlockLazy = lazy(() =>
    import('./WrappedBlock').then((component) => ({
        default: component.WrappedBlock,
    }))
)
